import type { ApiMeasurePoint } from '@highimpact-frontend/api-types';
import { api_config } from '../../../api-commons';
import { IMeasurePointService } from './IMeasurePointService';

class MeasurePointService implements IMeasurePointService {
  async add(params: ApiMeasurePoint): Promise<number> {
    const response = await api_config.post(
      '/measure-points/with-device-site',
      params
    );
    return response.data;
  }
}

const instance = new MeasurePointService();
export default instance;
